import { IDmMucHocPhiTinChiCopyRequest } from "../../../model/request/category/dmMucHocPhiTinChiCopyRequest";
import { IDmMucHocPhiTinChiViewModelRequest } from "../../../model/request/category/dmMucHocPhiTinChiViewModelRequest";
import {
  IDmMucHocPhiTinChi,
  IDmMucHocPhiTinChiGroupByLop,
} from "../../../model/respone/category/IDmMucHocPhiTinChi";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IDmMucHocPhiTinChiUpdate {
  id: number;
  dataField: string;
  newValue: number;
  data: IDmMucHocPhiTinChiGroupByLop;
}

export const eDmMucHocPhiTinChiActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: {} as IDmMucHocPhiTinChiViewModelRequest,
  LOAD_SUCCESS: {} as IDmMucHocPhiTinChi[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmMucHocPhiTinChi[],
  SAVE_SUCCESS: {} as IDmMucHocPhiTinChi[],
  SAVE_ERROR: "",

  CHANGE_VALUE: {} as IDmMucHocPhiTinChiGroupByLop,
  CHANGE_VALUE_ONE: {} as IDmMucHocPhiTinChiUpdate,

  CHANGE_REQUEST: {} as IDmMucHocPhiTinChiViewModelRequest,

  LOCK_START: {} as IDmMucHocPhiTinChiViewModelRequest,
  LOCK_SUCCESS: {} as IDmMucHocPhiTinChi[],
  LOCK_ERRR: "",

  UNLOCK_START: {} as IDmMucHocPhiTinChiViewModelRequest,
  UNLOCK_SUCCESS: {} as IDmMucHocPhiTinChi[],
  UNLOCK_ERRR: "",

  SHOWHIDE_COPY_MODAL: {} as boolean,
  COPY_START: {} as IDmMucHocPhiTinChiCopyRequest,
  COPY_SUCCESS: {} as IDmMucHocPhiTinChi[],
  COPY_ERROR: "",
  COPY_CHANGE_REQUEST: {} as any,
};
export const eDmMucHocPhiTinChiActionIds = generateActionTypeIds(
  eDmMucHocPhiTinChiActionsObj,
  "MUC_HOC_PHI_TIN_CHI"
);
export type IDmMucHocPhiTinChiActionTypes = IGenericActionType<
  typeof eDmMucHocPhiTinChiActionsObj,
  "MUC_HOC_PHI_TIN_CHI"
>;
